$shm_hitalama_entergate $mol_view
	title \Hitalama
	auto /
		<= offline_cleanup null
	sub /
		<= Form $shm_hitalama_entergate_form

$shm_hitalama_entergate_form $mol_view
	mode? \enter
	sub /
		<= Title $mol_view
			dom_name \h1
			sub / \Hitalama
		<= Mode_tabs $mol_view
			sub /
				<= Enter_tab $mol_link
					title \Вход
					current <= enter_current false
					arg *
						auth \enter
				<= Register_tab $mol_link
					title \Регистрация
					current <= register_current false
					arg *
						auth \register
		<= Access_label $mol_labeler
			title \Ключ доступа
			content /
				<= Access_token $shm_hitalama_entergate_access
					value? <=> access_token? \
					submit? <=> submit? null
		<= Mode_field $mol_view
			sub <= mode_field /$mol_view
		<= Actions $mol_view
			sub /
				<= Submit $mol_button_major
					title <= submit_title \Войти
					click? <=> submit? null
					enabled <= submit_enabled false
		<= Message $mol_text
			text <= message \
	Secret_label $mol_labeler
		title \Секретный ключ
		content /
			<= Secret_key $mol_string
				value? <=> secret_key? \
				hint \Вставьте секретный ключ
				submit? <=> submit? null
	Login_label $mol_labeler
		title \Имя
		content /
			<= Login $mol_string
				value? <=> login? \
				hint \Имя нового аккаунта
				submit? <=> submit? null

$shm_hitalama_entergate_access $mol_string
	type \text
	autocomplete true
	attr *
		^
		autocomplete \current-password
		autofocus true
